import { PreloadingStrategy, Route } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable,of, timer } from "rxjs";
import {mergeMap} from 'rxjs/operators';

@Injectable()
export class CustomPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (route.data && route.data['preload']) {
    
        if (route.data['delay']) {
        
          return timer(1000).pipe(mergeMap(() => load()));
        }
        else
        {
        
          return load();
        }
       
    } else {
      return of(null);
    }
  }
} 